import { Route, Routes } from "react-router-dom";
import useScrollToTop from "./Components/ScrollToTop";
import { Button, Result } from "antd";
import {
  ThemeProvider,
  unstable_createMuiStrictModeTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import dayjs_plugin_updateLocale from "dayjs/plugin/updateLocale";
import AlertProvider from "./Providers/util/Alert";
import AlertToast from "./Components/AlertToast";
import TimesheetProvider from "./Providers/Common/Timesheet";
import CommonJobsProvider from "./Providers/Common/Jobs";
import CountryStateCityProvider from "./Providers/Common/CountyStateCity";
import NotificationProvider from "./Providers/Common/Notification";
import UserProvider from "./Providers/Common/User";
import Signin from "./Pages/Auth/Signin";
import Home from "./Pages/Home/Home";
import { Aboutus } from "./Pages/Aboutus/Aboutus";
import Support from "./Pages/Support/Support";
import Pricing from "./Pages/Pricing/Pricing";
import Client from "./Pages/Client/Client";
import Vendor from "./Pages/Vendor/Vendor";
import Consultant from "./Pages/Consultant/Consultant";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndCondition from "./Pages/TermsCondition/TermsAndCondition";
import Faq from "./Pages/Faq/Faq";
import VendorRole from "./Pages/Dashboard/components/Roles/Vendor/Vendor";
import ConsultantRole from "./Pages/Dashboard/components/Roles/Consultant/Consultant";
import ClientRole from "./Pages/Dashboard/components/Roles/Client/Client";
import Signup from "./Pages/Auth/Signup";
import InviteSignup from "./Pages/Auth/InviteSignup";
import SignupSuccessfull from "./Pages/Auth/SignupSuccessfull";
import ForgotPassword from "./Pages/Auth/ForgotPassword";
import ShareTimesheetWrapper from "./Pages/ShareTimesheet/ShareTimesheet";
import { roles } from "./Utils/constants";
import Holder from "./Holder";
import VendorsC from "./Pages/Dashboard/components/Vendors";
import ConsultantscardC from "./Pages/Dashboard/components/Dashboard/DashboardCards/Consultants";
import VendorscardC from "./Pages/Dashboard/components/Dashboard/DashboardCards/Vendors";
import JobscardC from "./Pages/Dashboard/components/Dashboard/DashboardCards/Jobs";
import TimesheetC from "./Pages/Dashboard/components/Dashboard/DashboardCards/Timesheet";
import InvoiceC from "./Pages/Dashboard/components/Dashboard/DashboardCards/InvoiceCard";
import JobsC from "./Pages/Dashboard/components/Jobs";
import AddUser from "./Pages/CombinedDashboard/Users/AddUser.jsx";
import UserProfile from "./Pages/CombinedDashboard/Users/Profile";

// Client Providers
import ProjectProviderC from "./Providers/Client/Project";
import VendorProviderC from "./Providers/Client/Vendor";
import JobsProviderC from "./Providers/Client/Jobs";
import CountProviderC from "./Providers/Client/Count";
import TimesheetProviderC from "./Providers/Client/Timesheet";
import InvoiceProviderC from "./Providers/Client/invoice";
import DashboardC from "./Pages/Dashboard/components/Dashboard";

import OngoingJobInformationC from "./Pages/Dashboard/components/Dashboard/OngoingJobInformation";
import DiscoverC from "./Pages/Dashboard/components/Discover";
import MyAccountC from "./Pages/Dashboard/components/MyAccount";
import EditClientProfile from "./Pages/Dashboard/components/Roles/Client/EditClientProfile";
import Settings from "./Pages/CombinedDashboard/Settings";
import ViewInvoiceC from "./Pages/Dashboard/components/Invoices/ViewInvoice";
import DaywiseC from "./Pages/Dashboard/components/Dashboard/DashboardCards/Timesheet/Daywise";
import ProjectInformationC from "./Pages/Dashboard/components/Dashboard/ProjectInformation";

// Vendors
import ConnectionProviderV from "./Providers/Vendor/Connections";
import ProjectProviderV from "./Providers/Vendor/Project";
import JobProviderV from "./Providers/Vendor/Jobs";
import TimesheetProviderV from "./Providers/Vendor/Timesheet";
import InvoiceProviderV from "./Providers/Vendor/invoice";
import CountProviderV from "./Providers/Vendor/Count";

import DashboardV from "./Pages/DashboardVendor/components/Dashboard";
import MyAccountV from "./Pages/DashboardVendor/components/MyAccount";
import TimesheetV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Timesheet";
import DaywiseV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Timesheet/Daywise";
import ClientsV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Clients";
import ConsultantsV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Consultants";
import VendorsV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Vendors";
import CurrentClientsV from "./Pages/DashboardVendor/components/Clients";
import CurrentVendorsV from "./Pages/DashboardVendor/components/Vendors";
import CurrentConsultantsV from "./Pages/DashboardVendor/components/Consultants";
import InvoiceV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Invoices";
import ViewInvoiceV from "./Pages/DashboardVendor/components/invoices/ViewInvoice";
import OngoingJobInformationV from "./Pages/DashboardVendor/components/Dashboard/OngoingJobInformation";
import JobscardV from "./Pages/DashboardVendor/components/Dashboard/DashboardCards/Jobs";
import JobsV from "./Pages/DashboardVendor/components/Jobs";
import Invoices from "./Pages/DashboardVendor/components/Invoices";
import JobInformationV from "./Pages/DashboardVendor/components/invoices/JobInformation";
import ProjectInformationV from "./Pages/DashboardVendor/components/Dashboard/ProjectInformation";
import EditVendorProfile from "./Pages/Dashboard/components/Roles/Vendor/EditVendorProfile";
import FindJobsV from "./Pages/DashboardVendor/components/FindJobs";

// Vendors
import DashboardConsultant from "./Pages/DashboardConsultant/components/DashboardConsultant";
import EditConsultantProfile from "./Pages/Dashboard/components/Roles/Consultant/EditConsultantProfile";
import MyAccountCt from "./Pages/DashboardConsultant/components/MyAccount";
import TimesheetCardCt from "./Pages/DashboardConsultant/components/Dashboard/DashboardCards/Timesheet";
import JobProviderCt from "./Providers/Consultant/Jobs";
import CountProviderCt from "./Providers/Consultant/Count";
import TimesheetProviderCt from "./Providers/Consultant/Timesheet";
import FindJobsCt from "./Pages/DashboardConsultant/components/FindJobs";
import DaywiseCt from "./Pages/DashboardConsultant/components/Dashboard/DashboardCards/Timesheet/Daywise";
import TimesheetCt from "./Pages/DashboardConsultant/components/Timesheet";
import MyJobsCt from "./Pages/DashboardConsultant/components/MyJobs";
import OngoingJobInformationCt from "./Pages/DashboardConsultant/components/Dashboard/OngoingJobInformation";
import DetailedTimesheetCt from "./Pages/DashboardConsultant/components/Timesheet/DetailedTimesheet";
import Users from "./Pages/CombinedDashboard/Users";
import Blog from "./Components/Blog";

const theme = unstable_createMuiStrictModeTheme({
  palette: {
    primary: {
      main: "#2EBAA3",
    },
    secondary: {
      main: "#FFFFFF",
    },
  },
});

const App = () => {
  useScrollToTop();
  moment.updateLocale("en", {
    week: {
      dow: 1,
    },
  });

  dayjs.extend(dayjs_plugin_updateLocale);
  dayjs.updateLocale("en", {
    weekStart: 1,
  });

  const isSignedIn = useSelector((state) => state.user.value);
  const role = useSelector((state) => state.user.role);

  console.log(role);
  return (
    // Common Providers
    <ThemeProvider theme={theme}>
      <CountryStateCityProvider>
        <NotificationProvider>
          <UserProvider>
            <TimesheetProvider>
              <CommonJobsProvider>
                {/* Client Providers */}
                <ProjectProviderC>
                  <VendorProviderC>
                    <JobsProviderC>
                      <TimesheetProviderC>
                        <InvoiceProviderC>
                          <CountProviderC>
                            {/* Vendor Providers */}
                            <ConnectionProviderV>
                              <ProjectProviderV>
                                <JobProviderV>
                                  <TimesheetProviderV>
                                    <InvoiceProviderV>
                                      <CountProviderV>
                                        {/* Consultant Providers */}
                                        <JobProviderCt>
                                          <TimesheetProviderCt>
                                            <CountProviderCt>
                                              <AlertProvider>
                                                <AlertToast />
                                                <Routes>
                                                  <Route
                                                    path="/"
                                                    element={<Home />}
                                                  />
                                                  <Route
                                                    path="/aboutus"
                                                    element={<Aboutus />}
                                                  />
                                                  <Route
                                                    path="/contact"
                                                    element={<Support />}
                                                  />
                                                  <Route
                                                    path="/pricing"
                                                    element={<Pricing />}
                                                  />
                                                  <Route
                                                    path="/blog"
                                                    element={<Blog />}
                                                  />
                                                  <Route
                                                    path="/client"
                                                    element={<Client />}
                                                  />
                                                  <Route
                                                    path="/vendor"
                                                    element={<Vendor />}
                                                  />
                                                  <Route
                                                    path="/consultant"
                                                    element={<Consultant />}
                                                  />
                                                  <Route
                                                    path="/privacypolicy"
                                                    element={<PrivacyPolicy />}
                                                  />
                                                  <Route
                                                    path="/termsandcondition"
                                                    element={
                                                      <TermsAndCondition />
                                                    }
                                                  />
                                                  <Route
                                                    path="/faq"
                                                    element={<Faq />}
                                                  />
                                                  <Route
                                                    path="/vendor/profile/:userid"
                                                    element={<VendorRole />}
                                                  />
                                                  <Route
                                                    path="/consultant/profile/:userid"
                                                    element={<ConsultantRole />}
                                                  />
                                                  <Route
                                                    path="/client/profile/:userid"
                                                    element={<ClientRole />}
                                                  />
                                                  <Route
                                                    path="/signin"
                                                    element={
                                                      <Signin role={role} />
                                                    }
                                                  />
                                                  <Route
                                                    path="/signup"
                                                    element={
                                                      <Signup role={role} />
                                                    }
                                                  />
                                                  <Route
                                                    path="/signup/:inviteid"
                                                    element={
                                                      <InviteSignup
                                                        role={role}
                                                      />
                                                    }
                                                  />
                                                  <Route
                                                    path="/signedup"
                                                    element={
                                                      <SignupSuccessfull />
                                                    }
                                                  />
                                                  <Route
                                                    path="/resetpassword"
                                                    element={<ForgotPassword />}
                                                  />
                                                  <Route
                                                    path="/timesheet/:token"
                                                    element={
                                                      <ShareTimesheetWrapper />
                                                    }
                                                  />
                                                  <Route
                                                    path="/changepassword/:id"
                                                    element={<ForgotPassword />}
                                                  />
                                                  {/* Client */}
                                                  {role === roles.client && (
                                                    <Route
                                                      path="/dashboard"
                                                      element={<Holder />}
                                                    >
                                                      <Route
                                                        path=""
                                                        element={<DashboardC />}
                                                      />
                                                      <Route
                                                        path="timesheet/:token"
                                                        element={<DaywiseC />}
                                                      />
                                                      <Route
                                                        path="my-account"
                                                        element={<MyAccountC />}
                                                      />
                                                      <Route
                                                        path="my-account/edit"
                                                        element={
                                                          <EditClientProfile />
                                                        }
                                                      />
                                                      <Route
                                                        path="vendors"
                                                        element={<VendorsC />}
                                                      />
                                                      <Route
                                                        path="consultantscard"
                                                        element={
                                                          <ConsultantscardC />
                                                        }
                                                      />
                                                      <Route
                                                        path="vendorscard"
                                                        element={
                                                          <VendorscardC />
                                                        }
                                                      />
                                                      <Route
                                                        path="jobscard"
                                                        element={<JobscardC />}
                                                      />
                                                      <Route
                                                        path="jobscard/:id"
                                                        element={
                                                          <OngoingJobInformationC />
                                                        }
                                                      />
                                                      <Route
                                                        path="jobs/:id"
                                                        element={
                                                          <OngoingJobInformationC />
                                                        }
                                                      />
                                                      <Route
                                                        path="jobs/:id/timesheet/:timesheetid"
                                                        element={
                                                          <DaywiseC
                                                            showDatePicker
                                                          />
                                                        }
                                                      />
                                                      <Route
                                                        path="jobscard/:id/timesheet/:timesheetid"
                                                        element={
                                                          <DaywiseC
                                                            showDatePicker
                                                          />
                                                        }
                                                      />
                                                      <Route
                                                        path="timesheetscard"
                                                        element={<TimesheetC />}
                                                      />
                                                      <Route
                                                        path="timesheet/:token"
                                                        element={<DaywiseC />}
                                                      />
                                                      <Route
                                                        path="timesheetscard/:timesheetid"
                                                        element={<DaywiseC />}
                                                      />
                                                      <Route
                                                        path="invoices"
                                                        element={<InvoiceC />}
                                                      />
                                                      <Route
                                                        path="invoicescard"
                                                        element={<InvoiceC />}
                                                      />
                                                      <Route
                                                        path="invoices/:id/:jobid"
                                                        element={
                                                          <ViewInvoiceC />
                                                        }
                                                      />
                                                      <Route
                                                        path="invoicescard/:id/:jobid"
                                                        element={
                                                          <ViewInvoiceC />
                                                        }
                                                      />
                                                      <Route
                                                        path="discover"
                                                        element={<DiscoverC />}
                                                      />
                                                      <Route
                                                        path="project/:projectid"
                                                        element={
                                                          <ProjectInformationC />
                                                        }
                                                      />
                                                      <Route
                                                        path="jobs"
                                                        element={<JobsC />}
                                                      />
                                                      <Route
                                                        path="settings"
                                                        element={<Settings />}
                                                      />
                                                      <Route
                                                        path="user"
                                                        element={<Users />}
                                                      >
                                                        <Route
                                                          path="profile"
                                                          element={
                                                            <UserProfile />
                                                          }
                                                        />
                                                        <Route
                                                          path="adduser"
                                                          element={<AddUser />}
                                                        />
                                                        <Route
                                                          path="edituser/:id"
                                                          element={<AddUser />}
                                                        />
                                                      </Route>
                                                    </Route>
                                                  )}

                                                  {/* Vendor */}
                                                  {role === roles.vendor && (
                                                    <>
                                                      <Route
                                                        path="/dashboard"
                                                        // element={
                                                        //   role === roles.vendor ? (
                                                        //     <>
                                                        //       {console.log("correct")}
                                                        //       <Holder />
                                                        //     </>
                                                        //   ) : (
                                                        //     <>
                                                        //       {console.log("correct")}
                                                        //       <Signin />
                                                        //     </>
                                                        //   )
                                                        // }
                                                        element={<Holder />}
                                                      >
                                                        <Route
                                                          path=""
                                                          element={
                                                            <DashboardV />
                                                          }
                                                        />
                                                        <Route
                                                          path="find-jobs"
                                                          element={
                                                            <FindJobsV />
                                                          }
                                                        />
                                                        <Route
                                                          path="clients"
                                                          element={
                                                            <CurrentClientsV />
                                                          }
                                                        />
                                                        <Route
                                                          path="vendors"
                                                          element={
                                                            <CurrentVendorsV />
                                                          }
                                                        />
                                                        <Route
                                                          path="consultants"
                                                          element={
                                                            <CurrentConsultantsV />
                                                          }
                                                        />
                                                        <Route
                                                          path="my-account"
                                                          element={
                                                            <MyAccountV />
                                                          }
                                                        />
                                                        <Route
                                                          path="my-account/edit"
                                                          element={
                                                            <EditVendorProfile />
                                                          }
                                                        />
                                                        <Route
                                                          path="timesheetscard"
                                                          element={
                                                            <TimesheetV />
                                                          }
                                                        />
                                                        <Route
                                                          path="timesheet/:token"
                                                          element={<DaywiseV />}
                                                        />
                                                        <Route
                                                          path="clientscard"
                                                          element={<ClientsV />}
                                                        />
                                                        <Route
                                                          path="vendorscard"
                                                          element={<VendorsV />}
                                                        />
                                                        <Route
                                                          path="consultantscard"
                                                          element={
                                                            <ConsultantsV />
                                                          }
                                                        />
                                                        <Route
                                                          path="invoicescard"
                                                          element={<InvoiceV />}
                                                        />
                                                        <Route
                                                          path="jobscard"
                                                          element={
                                                            <JobscardV />
                                                          }
                                                        />
                                                        <Route
                                                          path="jobscard/:id"
                                                          element={
                                                            <OngoingJobInformationV />
                                                          }
                                                        />
                                                        <Route
                                                          path="jobs/:id/timesheet/:timesheetid"
                                                          element={
                                                            <DaywiseV
                                                              showDatePicker
                                                            />
                                                          }
                                                        />
                                                        <Route
                                                          path="jobscard/:id/timesheet/:timesheetid"
                                                          element={
                                                            <DaywiseV
                                                              showDatePicker
                                                            />
                                                          }
                                                        />
                                                        <Route
                                                          path="jobs/:id"
                                                          element={
                                                            <OngoingJobInformationV />
                                                          }
                                                        />
                                                        <Route
                                                          path="invoices/:id/:jobid"
                                                          element={
                                                            <ViewInvoiceV />
                                                          }
                                                        />
                                                        <Route
                                                          path="timesheetscard/:timesheetid"
                                                          element={<DaywiseV />}
                                                        />
                                                        <Route
                                                          path="jobs"
                                                          element={<JobsV />}
                                                        />
                                                        <Route
                                                          path="invoices"
                                                          element={<Invoices />}
                                                        />
                                                        <Route
                                                          path="project/:projectid"
                                                          element={
                                                            <ProjectInformationV />
                                                          }
                                                        />
                                                        <Route
                                                          path="invoices/jobs/:jobid"
                                                          element={
                                                            <JobInformationV />
                                                          }
                                                        />
                                                        <Route
                                                          path="settings"
                                                          element={<Settings />}
                                                        />
                                                        <Route
                                                          path="user"
                                                          element={<Users />}
                                                        >
                                                          <Route
                                                            path="profile"
                                                            element={
                                                              <UserProfile />
                                                            }
                                                          />
                                                          <Route
                                                            path="adduser"
                                                            element={
                                                              <AddUser />
                                                            }
                                                          />
                                                          <Route
                                                            path="edituser/:id"
                                                            element={
                                                              <AddUser />
                                                            }
                                                          />
                                                        </Route>
                                                      </Route>
                                                    </>
                                                  )}

                                                  {/* Consultant */}
                                                  {role ===
                                                    roles.consultant && (
                                                    <Route
                                                      path="/dashboard"
                                                      element={<Holder />}
                                                    >
                                                      <Route
                                                        path=""
                                                        element={
                                                          <DashboardConsultant />
                                                        }
                                                      />
                                                      <Route
                                                        path="my-account"
                                                        element={
                                                          <MyAccountCt />
                                                        }
                                                      />
                                                      <Route
                                                        path="timesheetscard"
                                                        element={
                                                          <TimesheetCardCt />
                                                        }
                                                      />
                                                      <Route
                                                        path="timesheets"
                                                        element={
                                                          <TimesheetCt />
                                                        }
                                                      />
                                                      <Route
                                                        path="timesheets/:jobid"
                                                        element={
                                                          <DetailedTimesheetCt />
                                                        }
                                                      />
                                                      <Route
                                                        path="timesheetscard/:id"
                                                        element={<DaywiseCt />}
                                                      />
                                                      <Route
                                                        path="find-jobs"
                                                        element={<FindJobsCt />}
                                                      />
                                                      <Route
                                                        path="my-jobs"
                                                        element={<MyJobsCt />}
                                                      />
                                                      <Route
                                                        path="my-jobs/:id"
                                                        element={
                                                          <OngoingJobInformationCt />
                                                        }
                                                      />
                                                      <Route
                                                        path="my-account/edit"
                                                        element={
                                                          <EditConsultantProfile />
                                                        }
                                                      />
                                                      <Route
                                                        path="settings"
                                                        element={<Settings />}
                                                      />
                                                    </Route>
                                                  )}
                                                </Routes>
                                              </AlertProvider>
                                            </CountProviderCt>
                                          </TimesheetProviderCt>
                                        </JobProviderCt>
                                      </CountProviderV>
                                    </InvoiceProviderV>
                                  </TimesheetProviderV>
                                </JobProviderV>
                              </ProjectProviderV>
                            </ConnectionProviderV>
                          </CountProviderC>
                        </InvoiceProviderC>
                      </TimesheetProviderC>
                    </JobsProviderC>
                  </VendorProviderC>
                </ProjectProviderC>
              </CommonJobsProvider>
            </TimesheetProvider>
          </UserProvider>
        </NotificationProvider>
      </CountryStateCityProvider>
    </ThemeProvider>
  );
};

export default App;
